export default __webpack_public_path__ + "static/media/discord_white.f80b7583.svg";